import './style.scss';
import React, { Suspense } from 'react';
import BorderedText from '../../bordered-text';
import a1 from '../../../resources/images/dashboard/1.svg';
import a2 from '../../../resources/images/dashboard/2.svg';
import a3 from '../../../resources/images/dashboard/3.svg';
import a4 from '../../../resources/images/dashboard/4.svg';
import a5 from '../../../resources/images/dashboard/5.svg';
import a6 from '../../../resources/images/dashboard/6.svg';
import a7 from '../../../resources/images/dashboard/7.svg';
import a8 from '../../../resources/images/dashboard/8.svg';
import a9 from '../../../resources/images/dashboard/9.svg';
import bluePhoneAlan from '../../../resources/images/dashboard/blue-phone-alan.png';

const data = [
  { id: 1, name: '', image: a1, text: 'Track your mood in just seconds' },
  { id: 2, name: '', image: a2, text: 'Add voice memos on the go' },
  { id: 3, name: '', image: a3, text: 'Set achievable routines easily' },
  { id: 4, name: '', image: a4, text: 'Add video memos on the go' },
  {
    id: 5,
    name: '',
    image: a5,
    text: 'Learn breathing techniques to combat stress',
  },
  { id: 6, name: '', image: a6, text: 'Get support based on your data' },
  { id: 7, name: '', image: a7, text: 'Measure heart rate during sessions' },
  {
    id: 8,
    name: '',
    image: a8,
    text: 'Get daily quotes based on your situation',
  },
  { id: 9, name: '', image: a9, text: 'Connect to your Apple Watch' },
];

const dataDe = [
  { id: 1, name: '', image: a1, text: 'Mood check in 3 Sekunden' },
  { id: 2, name: '', image: a2, text: 'Sprachnotizen on the go' },
  { id: 3, name: '', image: a3, text: 'Alltagsroutinen einfach planen' },
  { id: 4, name: '', image: a4, text: 'Videonotizen flexibel hinzufügen' },
  { id: 5, name: '', image: a5, text: 'Atemübungen gegen akuten Stress' },
  { id: 6, name: '', image: a6, text: 'Unterstützung auf Basis deiner Daten' },
  { id: 7, name: '', image: a7, text: 'Puls messen während der Sessions' },
  { id: 8, name: '', image: a8, text: 'Tägliche Zitate passend zu deiner Lage' },
  { id: 9, name: '', image: a9, text: 'Kompatibel mit Apple Watch' },
];

const MainFeaturesList = ({ language = 'en' }) => {
  const items = language === 'de' ? dataDe : data;

  return (
    <Suspense fallback={<div>{language === 'de' ? 'Laden...' : 'Loading...'}</div>}>
      <div className="main-feature-list">
        <div className="main-feature-list__container">
          {language === 'en' &&
            <h2 className="h2">
              Main
              <BorderedText
              text="features"
              textColor="#5E8CFF"
              backgroundColor="#D4E0FF"
                rotate="-4"
              />
            </h2>
          }
          {language === 'de' &&
            <h2 className="h2">
              Haupt
              <BorderedText
                text="Funktionen"
                textColor="#5E8CFF"
                backgroundColor="#D4E0FF"
                rotate="-4"
              />
            </h2>
          }
          <div className="content">
            {items.map((item) => {
              return (
                <div key={item.id} className="element">
                  <img src={item.image} alt={item.text} />
                  <h4 className="h4">{item.text}</h4>
                </div>
              );
            })}
          </div>

          <div className="privacy-content">
            <div className="privacy-content__container">
              <div className="privacy-content__container-inner first">
                <img
                  src={bluePhoneAlan}
                  alt="Blue phone, what are your main goals?"
                />
              </div>
              <div className="privacy-content__container-inner second">
                {language === 'en' &&
                  <h2 className="h2">
                    Your privacy is
                    <BorderedText
                      text="key"
                      textColor="#EC6F47"
                      backgroundColor="#FFD2C3"
                      rotate="-4"
                    />
                  </h2>
                }
                {language === 'de' &&
                  <h2 className="h2">
                    Deine Privatsphäre an erster Stelle
                  </h2>
                }
                {language === 'en' &&
                  <p>
                    No registration is required to use Earkick. This means that we
                    have no personal data whatsoever about you. Your data belongs to
                    you and only to you.
                  </p>
                }
                {language === 'de' &&
                  <p>
                    Für Earkick brauchst du keine Registrierung. Wir speichern keinerlei persönliche Daten über dich. Deine Daten gehören dir – und nur dir.
                  </p>
                }

                {language === 'en' &&
                  <p>
                    We are not exposing it to third parties. Your data serves to
                    support you and is used to build better tools for everyone who
                    wants to manage anxiety in the future.
                  </p>
                }
                {language === 'de' &&
                  <p>
                    Alle Informationen bleiben auf deinem Gerät oder werden ausschließlich anonymisiert verarbeitet. So können wir die App verbessern, dich gezielt unterstützen und bessere Tools für alle entwickeln, die künftig ihre mentale Gesundheit erfolgreich meistern wollen. Eine Weitergabe an Dritte erfolgt ausdrücklich nicht.
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default MainFeaturesList;
